"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typoMobile = exports.typoDesktop = void 0;
var typoDesktop = ['input', 'linkLG', 'linkMD', 'overline', 'paragraphLG300', 'paragraphMD400', 'paragraphMD700', 'paragraphSM400', 'paragraphSM700', 'paragraphXS400', 'titleLG300', 'titleMD300', 'titleSM400', 'titleSM700', 'titleXS400', 'titleXS700'];
exports.typoDesktop = typoDesktop;
var typoMobile = ['input', 'linkLG', 'linkMD', 'overline', 'paragraphLG400', 'paragraphLG700', 'paragraphMD400', 'paragraphMD700', 'paragraphSM400', 'titleLG300', 'titleMD300', 'titleSM300', 'titleSM400', 'titleSM700', 'titleXL300'];
exports.typoMobile = typoMobile;